import './SelectableFilterItem.scss';

import { memoize } from 'lodash';
import React from 'react';
import tinycolor2 from 'tinycolor2';

import Icon from '../icons/Icon';
import ProgressBackground from '../ProgressBackground';
import SelectableItem from '../SelectableItem/SelectableItem';

const lightenColor = memoize((color) => {
    let rgb = tinycolor2(color).toRgb();
    for (let c of ['r', 'g', 'b']) {
        rgb[c] = (255 - rgb[c]) * 0.7 + rgb[c];
    }
    return tinycolor2(rgb).toHexString();
});

export default class SelectableFilterItem extends React.Component {
    render() {
        let { checked, color } = this.props,
            lightColor = lightenColor(color),
            backgroundColor = checked ? lightColor : 'white',
            progressBackground = checked ? color : lightColor,
            textColor = checked ? 'white' : 'black',
            countTextColor = checked ? 'white' : 'black';

        return (
            <SelectableItem
                className="SelectableFilterItem"
                checked={checked}
                style={{
                    backgroundColor: backgroundColor,
                    color: textColor,
                }}
                onChange={this.props.onChange}>
                <div className="count" style={{ color: countTextColor }}>
                    {this.props.count}
                    {this.props.iconCount ? <Icon className="marginLeft" src={this.props.iconCount} color={countTextColor} size={24} /> : null}
                </div>
                <ProgressBackground value={this.props.percentage} color={progressBackground} />
                <div style={{ color: textColor }}>{this.props.children}</div>
            </SelectableItem>
        );
    }
}
